import React from 'react';
import Modal from 'react-modal';
import EqualPaymentPlanModal from './EqualPaymentPlanModal';
import { installMentPlans } from '@rb-serve-app/core';
import { EventType, useAnalytics } from '../ui/Analytics';

interface EPPModalProps {
  selectedPlan: installMentPlans | null;
  onClose: () => void;
  contentData: any;
  entries: any;
  featureFlaggingData: any;
}

const EPPModal: React.FC<EPPModalProps> = ({
  selectedPlan,
  onClose,
  contentData,
  entries,
  featureFlaggingData,
}) => {
  const { trackEvent } = useAnalytics();

  const handleTermsClick = () => {
    onClose();
    window.open(`${entries?.rb_epp?.eppTermsConditionsUrl}`, '_blank');

    trackEvent(
      EventType.CLICK_EVENT,
      ['modal plan details', 'enroll equal payment plans'],
      window.location.href,
      'model plan details | terms and conditions'
    );

    if (window.scrollY !== 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Modal
      isOpen={!!selectedPlan}
      onRequestClose={onClose}
      className={`fixed inset-[-9px] md:inset-0 lg:inset-0 z-50 flex items-center justify-end p-0 md:p-1 transition-transform duration-300 ${
        window.innerWidth >= 1024 ? 'translate-x-0' : 'translate-x-2'
      }`}
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      contentLabel="Plan Details Modal"
    >
      <div className="bg-white rounded-lg shadow-lg max-w-full w-full lg:max-w-[570px] md:max-w-[540px] h-full">
        {selectedPlan && (
          <EqualPaymentPlanModal
            plan={selectedPlan}
            handleCloseModal={onClose}
          />
        )}
      </div>
      <div className="flex text-[16px] absolute right-1 bottom-1 px-4 py-4 bg-[#FAFAFA] rounded-lg shadow-lg max-w-full w-full lg:max-w-[570px] md:max-w-[540px] justify-start items-center">
        <p className="text-black">
          {contentData.termsCondition1Title}{' '}
          <span
            className={`${
              featureFlaggingData ? 'text-primary-red' : 'text-gray-400'
            } cursor-pointer hover:underline`}
            onClick={handleTermsClick}
          >
            {contentData.termsCondition2Title}
          </span>
        </p>
      </div>
    </Modal>
  );
};

export default EPPModal;
